export enum MenuItemType {
    MAIN_UPPER = "MAIN_UPPER",
    MAIN_LOWER = "MAIN_LOWER",
    SECONDARY = "Secondary",
}

interface IMenuItem {
    id: string;
    textLabel: string;
    name: string;
    itemType: MenuItemType;
    icon: string;
    navigation: string | (() => any);
    nestedMenu?: any;
    routerLinkActiveClass?: string;
    description?: string;
    styleClasses?: string[];
    permissionsExcept?: string[];
    excludedRoles?: string[];
    permissionsOnly?: string[];
    includedRoles?: string[];
    tooltip?: Record<any, any>;
}

export class MenuItem implements IMenuItem {
    id: string;
    textLabel: string;
    name: string;
    description: string;
    itemType: MenuItemType;
    icon: string;
    styleClasses: string[];
    routerLinkActiveClass: string;

    // for mat menu customization
    nestedMenu: any;

    //excluded permissions and roles will be in the higher prior than included ones
    permissionsExcept: string[] = [];
    excludedRoles: string[] = [];

    permissionsOnly: string[] = [];
    includedRoles: string[] = [];

    navigation: string | (() => any) = null;
    tooltip: Record<any, any>;

    constructor(json: IMenuItem = null) {
        if (json) {
            Object.assign(this, json);

            if (!json.hasOwnProperty("routerLinkActiveClass")) {
                this.routerLinkActiveClass = "active";
            }
        }
    }

    get isMainUpperItem() {
        return this.itemType === MenuItemType.MAIN_UPPER;
    }

    get isMainLowerItem() {
        return this.itemType === MenuItemType.MAIN_LOWER;
    }

    get isSecondaryItem() {
        return this.itemType === MenuItemType.SECONDARY;
    }

    get styleClassesString() {
        return this.styleClasses?.join(" ") || "";
    }
}
